import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface AuthUser {
	id: string
	email: string
	name: string
}

interface AuthState {
	token: string | null
	user: AuthUser | null
}

// NOTE: Token lives in Redux memory only (not localStorage/sessionStorage).
// This is intentional — persisting JWTs in Web Storage exposes them to XSS.
// Token re-acquisition on page load must be handled in the auth ticket
// (e.g., silent refresh via an HttpOnly cookie, or re-login prompt).
const initialState: AuthState = {
	token: null,
	user: null,
}

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setCredentials(state, action: PayloadAction<{ token: string; user: AuthUser }>) {
			state.token = action.payload.token
			state.user = action.payload.user
		},
		logout(state) {
			state.token = null
			state.user = null
		},
	},
})

export const { setCredentials, logout } = authSlice.actions
export default authSlice.reducer
